import React from 'react'
import { cn } from '../../lib/utils'

export interface UIDualProgressProps {
  /**
   * 인덱싱된 행 비율 (0-100) - 파란색
   */
  indexedValue: number
  /**
   * 검색가능한 행 비율 (0-100) - 주황색
   */
  searchableValue: number
  /**
   * 최대값 (기본값: 100)
   */
  max?: number
  /**
   * 컨테이너 클래스명
   */
  className?: string
}

/**
 * 이중 프로그레스 바 컴포넌트
 * 인덱싱 진행률(파란색)과 검색가능 진행률(주황색)을 겹쳐서 표시합니다.
 */
export const UIDualProgress = React.forwardRef<
  HTMLDivElement,
  UIDualProgressProps
>(({ indexedValue, searchableValue, max = 100, className }, ref) => {
  const normalizedIndexed = Math.min(Math.max(indexedValue ?? 0, 0), max)
  const normalizedSearchable = Math.min(Math.max(searchableValue ?? 0, 0), max)

  const indexedPercentage = (normalizedIndexed / max) * 100
  const searchablePercentage = (normalizedSearchable / max) * 100

  return (
    <div
      ref={ref}
      className={cn(
        "relative w-full overflow-hidden rounded-full border border-gray-200 dark:border-gray-700 ring-1 ring-white/10 dark:ring-white/5 shadow-xs h-2 bg-muted/30",
        className
      )}
    >
      {/* Indexed Progress Bar (Blue - Background) */}
      <div
        className="absolute inset-0 h-full bg-blue-500 dark:bg-blue-400 transition-[width] duration-500 rounded-full"
        style={{ width: `${indexedPercentage}%` }}
      />
      {/* Searchable Progress Bar (Orange - Foreground) */}
      <div
        className="absolute inset-0 h-full bg-orange-500 dark:bg-orange-400 transition-[width] duration-500 rounded-full"
        style={{ width: `${searchablePercentage}%` }}
      />
    </div>
  )
})

UIDualProgress.displayName = "UIDualProgress"
